export const API_ERROR = 'BROKER_UNEXPECTED_ERROR';
export const API_NO_RESPONSE = 'BROKER_NO_RESPONSE';
export const API_NOT_AUTHORISED = 'BROKER_NOT_AUTHORISED';
